import { render, staticRenderFns } from "./aShopDetailOutstock.vue?vue&type=template&id=04404e4f&scoped=true"
import script from "./aShopDetailOutstock.vue?vue&type=script&lang=js"
export * from "./aShopDetailOutstock.vue?vue&type=script&lang=js"
import style0 from "./aShopDetailOutstock.vue?vue&type=style&index=0&id=04404e4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04404e4f",
  null
  
)

export default component.exports